import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfoModal from "../../uploader/infoModal";
import NoPreview from "../noPreview";

const NonePreview = props => {
  const { previewContent } = props;
  // BEGIN REDUX STATE
  const fileName = useSelector(state =>
    (state.detailsDocument.info.details &&
        state.detailsDocument.info.details.fileName) ||
      "");
  const previewDetails = useSelector(state => state.detailsDocument.previewDetails);

  // END REDUX STATE
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [isNotCompliantShow, setIsNotCompliantShow] = useState(true);
  const errorMessage = (
    <span>
      {" "}
      File non conforme. Si prega di eliminarlo e ricaricarlo. <br></br>
      <a href="https://agyo.elevio.help/it/articles/630-digital-box-caricamento-file-non-conforme">
        Scopri di più.
      </a>
    </span>
  );

  useEffect(() => {
    if (
      fileName.includes(".pdf") ||
      fileName.includes(".png") ||
      fileName.includes(".jpeg") ||
      fileName.includes(".jpg")
    ) {
      setIsNotCompliantShow(true);
    }
  }, [fileName]);

  useEffect(() => {
    if (!previewContent && previewDetails.status.ended) setVisibleDialog(true);
  }, [previewContent]);

  return (
    <>
      {!isNotCompliantShow && (
        <InfoModal
          title={"File non conforme"}
          content={errorMessage}
          isVisible={visibleDialog}
          type="primary"
          onClose={() => setVisibleDialog(false)}
        />
      )}
      <div className={"container_preview "} style={{ height: "100%" }}>
        <NoPreview />
      </div>
    </>
  );
};

export default NonePreview;
